/**
 * OVERRIDE TabularView.jsx
 */

import TabularView from '../../../../components/View/TabularView';

export default TabularView;